import { FindProductDialog as FindProductDialogComponent } from './FindProductDialog.component';
import { connector } from './FindProductDialog.connector';

export const FindProductDialog = connector(FindProductDialogComponent);
